"use client"

import { SectionTitle } from "@/components/SectionTitle"
import { useRecentPages } from "@/lib/hooks/useRecentPages"
import { RecentPageItem } from "./recent-page-item"

export function RecentlyViewed() {
  const [recentPages] = useRecentPages()
  return (
    <div className="space-y-4">
      <SectionTitle>Recently viewed</SectionTitle>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {recentPages.slice(0, 4).map((page) => (
          <RecentPageItem key={page.id} page={page} />
        ))}
      </div>
    </div>
  )
}
